import { render, staticRenderFns } from "./estadios.vue?vue&type=template&id=f4d859d8"
import script from "./estadios.vue?vue&type=script&lang=js"
export * from "./estadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports